import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

constructor(private http:HttpClient) { }

GetFullDate(Token:string):Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/General/GetFullDate?token="+Token).pipe(
    map(data=>{
      return data as any
    })
  )
}

GetNormalDate(Token:String):Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/General/GetNormalDate?token="+Token).pipe(
    map(data=>{
      return data as any
    })
  )
}

GetPeriod(Token:string):Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/General/GetPeriod?token="+Token).pipe(
    map(data=>{
      return data as any
    })
  )
}

}
